import React, { FC, useEffect, useState } from 'react';
import HistoryTab from '../surge-tabs/history';
import { SurgeTabProps } from '../surge-tabs/types';
import { HistoryItemType } from '../surge-tabs/history/types';
import { Paginate } from '@cokitchen/cokitchen-components';
import { apiService } from 'utils/api';

const GeneralSurgeHistory: FC<SurgeTabProps> = () => {
  const [loading, setLoading] = useState(false);
  const [historyList, setHistoryList] = useState<HistoryItemType[]>([]);
  const [pageCount, setPageCount] = useState<number>(1);
  const orderUrl = process.env.REACT_APP_ORDER_STATS_API_KEY;
  useEffect(() => {
    fetchLogisticsData();
  }, []);

  const fetchLogisticsData = async (pageNo = 1) => {
    setLoading(true);
    try {
      const res = await apiService.post(
        `logistics/super-admin/surge/general/instant/get/${pageNo}`,
        { baseUrl: orderUrl }
      );
      const response = res?.data?.data;
      setHistoryList(response);
      setPageCount(Math.ceil(+res?.data?.total / 10));
    } finally {
      setLoading(false);
    }
  };

  const getSelectedPageData = (val: { selected: number }) => {
    const pageNo = val?.selected + 1;
    fetchLogisticsData(pageNo);
  };

  return (
    <>
      <HistoryTab color='blue' loading={loading} historyList={historyList} />
      {!loading && <Paginate pageCount={pageCount} onPageChange={getSelectedPageData} />}
    </>
  );
};

export default GeneralSurgeHistory;
